import { EshopGlobalSettingController, SimpleGlobalSettingDto } from '@/api';

export default {
  getGlobalSetting: async (): Promise<SimpleGlobalSettingDto[]> => {
    const response = await EshopGlobalSettingController.getAll();
    return response.data!.data;
  },
};
